import { addDays } from 'date-fns'

import { formatDate, parseISODate } from '@avantstay/backoffice-core'

import { DueDatePeriodProps } from '@new/domains/fastBookingsTapeChart/components/ExtendedColumns/components/ArrivalsChecklistSidePanel/ArrivalsChecklistSidePanel.utils'

interface GetDueDatePeriodProps {
  dueDates?: DueDatePeriodProps
  fallbackEndDate: Date
  fallbackStartDate: Date
}

export const getDueDatePeriod = ({
  dueDates,
  fallbackEndDate,
  fallbackStartDate,
}: GetDueDatePeriodProps) => {
  const start = formatDate(dueDates?.start ?? fallbackStartDate)
  const end = formatDate(dueDates?.end ?? fallbackEndDate)
  const updatedEndDate = formatDate(addDays(parseISODate(end), 1))

  return { start, end: updatedEndDate }
}
